// extracted by mini-css-extract-plugin
module.exports = {"image":"CustomImage_image__eekNy"};